export default __webpack_public_path__ + "95278451133024913d5aa9a45a1d06d9.png";